import { useGetSimpleUpdateData } from '@cp-shared-19/frontend-integration';
import { Contract, ContractDetails as TContractDetails } from 'cpfr-common';
import { updateContracts } from './ContractsSlice';
import { ContractsDataSelector } from './ContractsDataSelector';

type UpdateContractsType = {
    updateContracts: (data: Array<Contract & TContractDetails>) => void;
    contractsData: Array<Contract & TContractDetails>;
};

export function useUpdateContractsAll(): UpdateContractsType {
    const {
        updateData,
        dataState: { data },
    } = useGetSimpleUpdateData(updateContracts, ContractsDataSelector);
    return {
        updateContracts: updateData,
        contractsData: data as Array<Contract & TContractDetails>,
    };
}
